import { useToast } from 'primevue/usetoast';
import { useGetData } from '~/composables/useGetData';
import { $formatDate } from '~/utils/formatters';
import { $parseErrorMessage, $sanitizeHtml } from '~/utils/helpers';

export default function useGetPrivacyPolicy() {
  const privacyPolicy = ref<string>();
  const lastUpdated = ref<string>();
  const loading = ref(false);

  const toast = useToast();

  const getPrivacyPolicy = async () => {
    if (loading.value) return;

    loading.value = true;

    try {
      const { execute, error } = await useGetData<{
        data: { content: string; updated_at: string | null };
      }>();
      const result = await execute('pages/privacy', {
        query: {
          raw: 1,
        },
      });

      if (error.value) {
        toast.add({
          severity: 'error',
          summary: $parseErrorMessage(error.value),
          life: 3000,
        });
      } else if (result && result.data.content) {
        privacyPolicy.value = $sanitizeHtml(result.data.content);
        lastUpdated.value = $formatDate(result.data.updated_at);
      }
    } catch (err) {
      toast.add({
        severity: 'error',
        summary: $parseErrorMessage(err),
        life: 3000,
      });
    }

    loading.value = false;
  };

  return {
    privacyPolicy,
    lastUpdated,
    loading,

    getPrivacyPolicy,
  };
}
